module.exports = __webpack_public_path__ + "img/0445_03.994271b6.jpg";